import React, { memo } from 'react';
import dayjs from 'dayjs';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import EditableField from '../../EditableField';
import { BookingStatus, TravelTypes } from '../../../constants';
import { setCruiseItineraryPaymentAmount } from '../../../store/slices/trip';

const StateroomPrice = ({
  priceInfo, doShowStateroomLabel, tripId, isTripSearch,
}) => {
  const { deposit, finalPayment, roomIndex } = priceInfo;
  const trip = useSelector((state) => state.trip.selectedTrips[tripId]);
  const { isLoggedIn } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const {
    tripConfirmation,
  } = useSelector((store) => store.trip);
  const formatNumber = (number) => <NumberFormat value={number} prefix="$" displayType="text" thousandSeparator fixedDecimalScale="true" decimalScale="2" />;
  const isConfirmation = tripConfirmation != null && tripConfirmation.tripId;

  const cruiseBooking = tripConfirmation && tripConfirmation.bookingResponses
    && _.find(tripConfirmation.bookingResponses, (t) => t.mode === TravelTypes.cruise);
  const isCruiseOnHold = trip && trip.itinerariesOnHold
    && !!_.find(trip.itinerariesOnHold, (it) => it.itineraryMode === TravelTypes.cruise);

  const handleSetPaymentAmount = (paymentAmount) => {
    dispatch(setCruiseItineraryPaymentAmount({ tripId, paymentAmount, roomIndex }));
  };

  return (
    <div className="text-xs xl:text-sm py-2">
      {doShowStateroomLabel && (
        <div>
          Stateroom
          {' '}
          {roomIndex + 1}
        </div>
      )}
      {deposit && deposit.dueDate && deposit.amount > 0
        && (
          <div className="mt-2 grid grid-cols-3 text-xs text-gray-600">
            <div className="col-span-2">
              Cruise deposit due
              {' '}
              {dayjs(deposit.dueDate).format('MMM DD, YYYY')}
            </div>
            <div className="text-right">
              <NumberFormat value={deposit.amount} prefix="$" displayType="text" thousandSeparator fixedDecimalScale="true" decimalScale="2" />
            </div>
          </div>
        )}
      {finalPayment && finalPayment.dueDate && finalPayment.amount > 0
        && (
          <div className="mt-2 grid grid-cols-3 text-xs text-gray-600">
            <div className="col-span-2">
              Cruise final payment due
              {' '}
              {dayjs(finalPayment.dueDate).format('MMM DD, YYYY')}
            </div>
            <div className="text-right">
              <NumberFormat value={finalPayment.amount} prefix="$" displayType="text" thousandSeparator fixedDecimalScale="true" decimalScale="2" />
            </div>
          </div>
        )}
      {isLoggedIn && !isTripSearch && deposit && trip
        && ((isConfirmation && cruiseBooking && !cruiseBooking.isPaymentMethodAdded
          && cruiseBooking.bookingStatus !== BookingStatus.cancelled)
          || (!isConfirmation && !isCruiseOnHold))
        && (
          <div className="mt-2 grid grid-cols-3 text-xs text-gray-600">
            <div className="col-span-2">
              Payment amount:
            </div>
            <div className="text-right">
              <EditableField
                defaultValue={trip && trip.cruisePayments
                  && _.find(trip.cruisePayments, (c) => c && c.roomIndex === roomIndex)
                  ? _.find(trip.cruisePayments, (c) => c && c.roomIndex === roomIndex).paymentAmount
                  : +deposit.amount}
                minValue={+deposit.amount}
                maxValue={+finalPayment.amount}
                formatter={formatNumber}
                onSave={handleSetPaymentAmount}
              />
            </div>
          </div>
        )}
    </div>
  );
};

StateroomPrice.propTypes = {
  priceInfo: PropTypes.shape().isRequired,
  doShowStateroomLabel: PropTypes.bool,
  tripId: PropTypes.string,
  isTripSearch: PropTypes.bool,
};

StateroomPrice.defaultProps = {
  doShowStateroomLabel: true,
  isTripSearch: true,
  tripId: undefined,
};

export default memo(StateroomPrice);
